import NavBar from "../NavBar";
// import { Navigation } from "../../ui-components";
import Footer from "./footer";

const Layout = ({ children, active, color }) => {
  return (
    <>
      <NavBar active={active} />
      <main id="main-content" tabIndex="-1">
        {children}
      </main>
      <Footer color={color} />
    </>
  );
};

export default Layout;
